import React from 'react';
import { Icon } from './Icon.js';
export const IconChocolateBar = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M19 12V22H5L5 12", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 2V12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M5 7L19 7L19 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 2H5L5 12", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M21 12L3 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChocolateBar.js.map